/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  
  // Bold:POv2
  if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    line_item = window.BOLD.common.cartDoctor.fixItem(line_item);
  }        
  
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.shoppingcart-box .list');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery("#preloader .errormessage .fulltext").text(str);
  showErrorMessage();
  setTimeout(hideErrorMessage, 3000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    beforeSend: function() {
      showPreloader();
    },
    success: function(line_item) {
      
      // Bold:POv2
      if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        line_item = window.BOLD.common.cartDoctor.fixItem(line_item);
      }        
      
      hidePreloader();
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      hidePreloader();
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {

  var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      beforeSend: function() {
        showPreloader();
      },
      success: function(line_item) {
        
        // Bold:POv2
        if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          line_item = window.BOLD.common.cartDoctor.fixItem(line_item);
        }  
        
        //Bold: Check for Product Bundle qualification
        if(typeof shappify_qb_main === 'function') {
          shappify_qb_main(successContents);
        }else{
          successContents(null);  
        }
        
        function successContents(cart){
          
          //Bold PO v2.0
          if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            cart = window.BOLD.common.cartDoctor.fix(cart);
          }
          
          if(cart != null){
            line_item = cart["items"][0];
          }
          hidePreloader();
          if ((typeof callback) === 'function') {
            callback(line_item);
          }
          else {
            Shopify.cartPopapForm(variant_id);
            Shopify.onItemAdded(line_item);
          }
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        hidePreloader();
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
  
    //Bold: Use our add-to-cart functionality to enable file uploads with AJAX
    if(typeof(BOLD)==='object' && BOLD.helpers && typeof(BOLD.helpers.addItemFromForm) === 'function'){
      BOLD.helpers.addItemFromForm(form_id, params.success, params.error);
      return;
    }
  
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var title = jQuery('.'+variant_id+':first .title').text();
	jQuery("#preloader .message .text").text(title+" - ");
  	showMessage();
  	setTimeout(hideMessage, 2000);
}
Shopify.cartPopapForm = function(variant_id) {
  var title = jQuery('.page-product-title:first').text();
	jQuery("#preloader .message .text").text(title+" - ");
  	showMessage();
  	setTimeout(hideMessage, 2000);
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  
  //Bold PO v2.0
  if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined') {
    cart = window.BOLD.common.cartDoctor.fix(cart);
  }

  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
			
          if (value.length) {
            jQuery(".cart-group-1").css({"display": "block"});
            jQuery(".cart-group-2").css({"display": "none"});
            var table = jQuery(cart_cell_id + '.list');
            jQuery.each(value, function(i, item) {
              /*if(i > 2){
                  return false;
              }*/
              jQuery('<div class="item"><div class="image"><a href="' + item.url + '" class="preview-image"><img src="' + item.image + '" alt="' + item.title + '"></a></div><div class="description"><a href="' + item.url + '">' + item.title + '<br>' + (item.properties_formatted || "") + '</a><strong class="price">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</strong></div><div class="buttons"><a href="javascript:;" onclick="Shopify.removeItem(' + item.variant_id + ')" title="Remove This Item" class="icon icon-sm flaticon-recycle59 remove-from-cart"></a></div></div>').appendTo(table);
              console.log('vhains g');
            });

          }
          else {
            jQuery(".cart-group-1").css({"display": "none"});
            jQuery(".cart-group-2").css({"display": "block"});
          }
        }
      });
    }
  }

  //BOLD PO v2.0
  if(typeof window.BOLD !== 'undefined' && typeof window.BOLD.options !== 'undefined') {
    window.BOLD.options.app.checkoutFix();
  }
  
  changeHtmlValue(".total .cart_list_total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".btn-shopping-cart .badge", cart.item_count);
  
  jQuery('.currencies .selected').trigger('click');
  
  //BOLD PO v2.0
  if(window.BOLD && BOLD.common && BOLD.common.eventEmitter){
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
  }
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
function showPreloader() {
  jQuery(".custom-loader").show();
}
function hidePreloader() {
  jQuery(".custom-loader").hide();
}
function showMessage() {
  jQuery("#preloader .message").show();
}
function hideMessage() {
  jQuery("#preloader .message").fadeOut(500);
}
function showErrorMessage() {
  jQuery("#preloader .errormessage").show();
}
function hideErrorMessage() {
  jQuery("#preloader .errormessage").fadeOut(500);
}